import { RESET_ERROR_MESSAGE } from '../actions';

export default function errorReducer(state = null, action) {
  const { type, error, ...rest } = action;

  if (type === RESET_ERROR_MESSAGE) {
    return null;
  } else if (error) {
    // ignore api errors that are in [400-499] range
    if (
      action.payload &&
      action.payload.status &&
      action.payload.status >= 400 &&
      action.payload.status < 500
    ) {
      return state;
    }
    return rest;
  }

  return state;
}
